var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import Image from "../assets/mofoLogo.svg";
export function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const { login, errorName, loading } = useAuth();
    const [localError, setLocalError] = useState("");
    const [appName, setAppName] = useState("");
    useEffect(() => {
        const hostname = window.location.hostname;
        const parts = hostname.split(".");
        if (parts.length > 2) {
            const subdomain = parts[1]; // "bap1" or "gdd" , etc
            console.log("subdomain", subdomain);
            let name = "";
            // map subdomains to user-friendly names
            switch (subdomain) {
                case "bap1":
                    name = "Offense";
                    break;
                case "gdd":
                    name = "Defense";
                    break;
                default:
                    name = "";
                    break;
            }
            setAppName(name);
        }
    }, []);
    console.log("appName: ", appName);
    const handleLogin = (e) => __awaiter(this, void 0, void 0, function* () {
        if (loading)
            return; // prevent multiple login attempts
        e.preventDefault();
        if (!username || !password) {
            setLocalError("Please provide both a username and password.");
            return;
        }
        setLocalError("");
        yield login(username.toLocaleLowerCase(), password);
    });
    // const handleLogout = async () => {
    // 	await logout()
    // 	alert("You have successfully logged out!")
    // }
    return (_jsx("form", Object.assign({ onSubmit: handleLogin, noValidate: true }, { children: _jsx("div", Object.assign({ className: "w-screen min-h-screen flex items-center justify-center overflow-hidden" }, { children: _jsxs("div", Object.assign({ className: "w-[300px] h-auto flex flex-col text-center gap-4" }, { children: [_jsxs("div", Object.assign({ className: "flex flex-col gap-16" }, { children: [_jsx("img", { src: Image, alt: "Modern Football Logo", className: "mx-auto" }), appName && (_jsx("h1", Object.assign({ className: "text-lg font-semibold text-mofoBrandBlack" }, { children: appName }))), _jsxs("div", Object.assign({ className: "w-full flex flex-col gap-2" }, { children: [_jsx("p", Object.assign({ className: "text-lg mb-2" }, { children: "Log in to your account:" })), localError && (_jsx("p", Object.assign({ className: "text-mofoRed transition-opacity duration-300" }, { children: localError }))), errorName && !localError && (_jsx("p", Object.assign({ className: "text-mofoRed transition-opacity duration-300" }, { children: errorName }))), _jsx("input", { placeholder: "Username", className: "p-2 border w-full rounded border-mofoBrandBlack", value: username, onChange: (e) => setUsername(e.target.value) }), _jsx("input", { placeholder: "Password", className: "p-2 border w-full rounded border-mofoBrandBlack", type: "password", value: password, onChange: (e) => setPassword(e.target.value) })] }))] })), _jsx("div", Object.assign({ className: "w-full h-[100px] flex flex-col gap-2" }, { children: _jsx("button", Object.assign({ className: "btn btn-xs px-4 h-10 rounded-md text-md bg-mofoBrandBlack border-mofoBrandBlack text-white font-sans click:scale-x-95", type: "submit", disabled: loading }, { children: loading ? "Logging in..." : "Login" })) }))] })) })) })));
}
